/**
 * OpenSearch search DSL dialect + compiler.
 *
 * OpenSearch shares almost all of Elasticsearch's DSL, so `OpenSearchDialect`
 * extends `ElasticsearchDialect` and overrides only the fragments that differ
 * (e.g. version-specific query clauses), rather than forking the compiler.
 */
import { ElasticsearchDialect } from './elasticsearch';
import { SearchDslCompiler } from './search-dsl-compiler';

export class OpenSearchDialect extends ElasticsearchDialect {
    override readonly engine = 'opensearch' as const;

    // Override individual fragments here if OpenSearch diverges from
    // Elasticsearch; inherited methods cover the shared behavior.
}

export class OpenSearchCompiler extends SearchDslCompiler {
    constructor() {
        super(new OpenSearchDialect());
    }
}
